/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'user_shape': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M15.844 16.155a2.804 2.804 0 00-.176-.286 4 4 0 00-2.595-1.713c-.907.63-1.99.958-3.099.958a5.429 5.429 0 01-3.098-.958 4.002 4.002 0 00-2.753 1.967A8.46 8.46 0 0010 18.489a8.46 8.46 0 005.844-2.334zm-12.75-1.22a5.556 5.556 0 013.732-2.289c.277-.05.554.026.806.202.68.504 1.485.755 2.342.755.856 0 1.663-.251 2.343-.755.226-.176.504-.252.806-.202 1.51.198 2.874 1.053 3.757 2.325A8.448 8.448 0 0018.49 10 8.492 8.492 0 0010 1.511c-4.686 0-8.489 3.805-8.489 8.489 0 1.84.587 3.544 1.583 4.935zM10 12.317a4.494 4.494 0 01-4.484-4.484A4.494 4.494 0 0110 3.35a4.494 4.494 0 014.484 4.484A4.494 4.494 0 0110 12.317zm0-7.455a2.978 2.978 0 00-2.973 2.972A2.978 2.978 0 0010 10.806a2.978 2.978 0 002.973-2.973A2.977 2.977 0 0010 4.862zM10 20C4.484 20 0 15.516 0 10S4.484 0 10 0s10 4.484 10 10-4.484 10-10 10z" _fill="#213F6B" fill-rule="evenodd"/>'
  }
})
